import { BoxProps, VStack, Text, useColorMode } from '@chakra-ui/react';
import { useSetState } from 'ahooks';
import { useEffect } from 'react';
import { TRANS_TABLE_CONFIG } from '../../../config/bizConfig';
import { useSearchParams } from '../../../hooks/useSearchParams';
import useIsMobile from '../../../iZUMi-UI-toolkit/src/hooks/useIsMobile';
import {
    getIziSwapTransRecord,
    RequestIziSwapTransRecord,
    ResponseIziTransRecord,
} from '../../../net/iZUMi-endpoints/src/restful/izumiSwapBase';
import { MultiPageData, MultiPageSetting } from '../../../net/iZUMi-endpoints/src/restful/types/multiPage';
import { i_text_copy } from '../../../style';
import { ChainId } from '../../../types/mod';
import { getColorThemeSelector } from '../../../utils/funcs';
import { isNumeric } from '../../../utils/valid';
import { TransactionList } from '../../components/TransactionList';

type TransactionsBlockProps = {
    variant?: any;
} & BoxProps;

export const TransactionBlock: React.FC<TransactionsBlockProps> = (props) => {
    const { ...rest } = props;
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const isMobile = useIsMobile();
    const [setting, setSetting] = useSetState<MultiPageSetting>({
        page: 1,
        pageSize: 10,
    });
    const [transData, setTransData] = useSetState<MultiPageData<ResponseIziTransRecord>>({
        data: [],
        totalPage: 1,
        loading: false,
    });

    const searchParams = useSearchParams();
    const tokenAddress = searchParams.get('tokenAddress') || undefined;
    const chainId = isNumeric(searchParams.get('chainId')) ? Number(searchParams.get('chainId')) : ChainId.BSC;

    useEffect(() => {
        // TODO: limit date range?
        const queryParams: RequestIziSwapTransRecord = {
            page: setting.page,
            page_size: setting.pageSize,
            chain_id: chainId,
            token_addr: tokenAddress,
        };
        getIziSwapTransRecord(queryParams).then((r) => {
            // TODO loading status
            const data = r.data.is_success ? r.data.data : [];
            const totalPage = r.data.is_success ? Math.ceil(r.data.total / setting.pageSize) : 1;
            const limitTotalPage = Math.min(totalPage, TRANS_TABLE_CONFIG.MAX_LIST_ITEM / setting.pageSize);
            setTransData({ data, totalPage: limitTotalPage });
        });
    }, [setting, chainId, tokenAddress]);

    return (
        <VStack
            w={{ base: '100%', sm: '1150px' }}
            alignItems="left"
            mt={{ base: '20px !important', sm: '60px !important' }}
            spacing="20px"
            {...rest}
        >
            {!isMobile && (
                <Text className={i_text_copy} fontSize="14px" color={colorTheme('gray.500', 'gray.0')}>
                    Transactions
                </Text>
            )}

            <TransactionList
                setting={setting}
                pageData={transData}
                setCurrentPage={(page: number) => setSetting({ page })}
                setPageSize={(pageSize: number) => setSetting({ pageSize })}
            />
        </VStack>
    );
};
